import "./App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import NoPage from "./components/NoPage";
import Navbar from "./components/Navbar";

import { useEffect, useState } from "react";
import ImageMarkerGenerator from "./components/tools/generators/ImageMarkerGenerator";
import Editor from "./components/Editor";
import Modal from "./components/Modal";
import Main from "./components/Main";
import ZipImageDropper from "./components/ZipImageDropper";
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}

function App() {
  useEffect(() => {
    if (window.top === window.self) {
      //   window.location.href = "https://guru-x.de/data/edit";
    }
  }, []);
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="w-full ">
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="*" element={<NoPage />} />
          {/** Tools section */}
          <Route path="tools/imagemarker" element={<ImageMarkerGenerator />} />
          {/**  </Route>*/}
        </Routes>{" "}
      </div>{" "}
    </BrowserRouter>
  );
}

export default App;
